export const T = {
  en_GB: {
    failedToLoad: "Failed to load the dynamic portfolio.",
  },
  nb_NO: {
    failedToLoad: "Kunne ikke laste den dynamiske porteføljen.",
  },
} as const;
